/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthRedirectSsoLogin$Params {
  'x-trace-id'?: string;
  redirect_uri: string;
}

export function authRedirectSsoLogin(http: HttpClient, rootUrl: string, params: AuthRedirectSsoLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, authRedirectSsoLogin.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.query('redirect_uri', params.redirect_uri, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

authRedirectSsoLogin.PATH = '/api/auth/sso-login';
